import { Head, Link } from '@inertiajs/react'
import { Box, Button, Section, Text } from '@radix-ui/themes'
import ManagerPageHeader from '@/shared/manager/ManagerPageHeader'
import CarReviewsTable from '@/shared/tables/track_manager/CarReviewsTable'
import { TrackManagerCarReviewsHistoryProps } from '@/types/track_manager_car_reviews'

export default function CarReviewsHistory({ reviews }: TrackManagerCarReviewsHistoryProps) {
  return (
    <div className="flex">
      <Head title="Car review history" />
      <div className="grow min-w-0">
        <ManagerPageHeader title="Car review history">
          <Button variant="soft" color="gray" asChild>
            <Link href="/track_manager/car_reviews">Back to queue</Link>
          </Button>
        </ManagerPageHeader>
        <Section size="1">
          <Box px={{ initial: '3', sm: '0' }}>
            <Text as="p" color="gray" mb="3">
              The last 200 decisions. Open one to change it.
            </Text>
            {reviews.length === 0 ? <Text color="gray">No decisions yet.</Text> : <CarReviewsTable reviews={reviews} />}
          </Box>
        </Section>
      </div>
    </div>
  )
}
